// extracted by mini-css-extract-plugin
module.exports = {"content":"ContentRouters_content__KRFUr"};